import React, {Component} from 'react'
import Attendance from './Attendance'
import Authentication from '../../../../modules/Authentication'
import Members from '../../../../api/Members'
import AttendanceApi from '../../../../api/Attendance'
import DropdownsApi from '../../../../api/Dropdowns'
import {message} from 'antd'
import User from '../../../../api/User'

class AttendanceCont extends Component {
  state = {
    fetching: true,
    fetchingActions: true,
    list: [],
    actions: [],
    toggled: false,
    updating: false,
    status: 'Inactive',
    member: {},
    profile: {},
  }
  auth = new Authentication()
  membersApi = new Members()
  api = new AttendanceApi()
  dropdwonsApi = new DropdownsApi()
  userApi = new User()

  async componentDidMount() {
    await this.fetch()
    await this.fetchActions()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const list = await this.api.staff()
      const {status, lastUpdate, location} = await this.api.status()
      this.setState({
        profile: this.auth.getProfile(),
        member: this.auth.getMember(),
        list,
        status,
        location,
        lastUpdate,
        fetching: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }

  fetchActions = async () => {
    try {
      this.setState({
        fetchingActions: true,
      })
      const actions = await this.dropdwonsApi.read('attendance', 'actions')
      this.setState({
        actions,
      })
      this.setState({
        fetchingActions: false,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetchingActions: false})
    }
  }

  onToggle = async value => {
    await this.api.action({action: !value ? 'login' : 'logoff'})
    this.setState({
      toggled: !value,
      status: !value ? 'active' : 'inactive',
    })
  }
  updateStatus = async key => {
    this.setState({
      updating: true,
    })
    await this.api.status({status: key})
    this.setState({
      updating: false,
    })
  }
  operations = async e => {
    try {
      if (e.key === 'logout') {
        this.setState({
          updating: true,
        })
        await this.userApi.logout()
        this.setState({
          updating: false,
        })
        this.auth.logout()
        window.location = '#/login'
      } else {
        if (e.key !== 'account') {
          await this.api.action({action: e.key})
          await this.fetch()
        }
      }
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({updating: false})
    }
  }

  render() {
    const {fetchingActions, fetching} = this.state
    return (
      <Attendance
        {...this.state}
        onToggle={this.onToggle}
        fetch={this.fetch}
        fetchingActions={fetchingActions}
        fetchingList={fetching}
        updateStatus={this.updateStatus}
        operations={this.operations}
      />
    )
  }
}

AttendanceCont.propTypes = {}
AttendanceCont.defaultProps = {}

export default AttendanceCont
